import axios from 'axios'
import { getHeaders, getError } from '../helpers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    conversation: { suggestions, rejectSuggestions },
  },
} = config

/**
 * Get suggestion by conversation ID
 * @param {object} params
 * @param {string} params.conversationId
 *
 * @returns {Promise<{
 *  hasSuggestions: boolean,
 *  suggestions: [{
 *    logId: string,
 *    id: string,
 *    content: string,
 *    confidence: string,
 *    attachments: [object],
 *    buttons: [object]
 *  }]
 * }>}
 */
const getByConversationId = async (params) => {
  const { conversationId } = params

  try {
    const { data } = await axios({
      url: suggestions.replace(':conversationId', conversationId),
      method: 'get',
      headers: getHeaders(true)
    })

    return data
  } catch(error) {
    return {
      hasSuggestions: false,
      suggestions: []
    }
  }
}

/**
 * Reject suggestion by id
 * @param {object} params
 * @param {string} params.logId
 * @param {string} params.suggestionId
 * @param {string} params.conversationId
 *
 * @returns {Promise<{
 *  isOK: boolean
 * }>}
 */
const rejectById = async (params) => {
  const { suggestionId, conversationId, logId } = params

  try {
    await axios({
      url: rejectSuggestions.replace(':conversationId', conversationId),
      method: 'post',
      headers: getHeaders(true),
      data: {
        logId,
        suggestionId
      }
    })

    return { isOK: true }
  } catch(error) {
    throw getError(error)
  }
}

export default {
  getByConversationId,
  rejectById
}
